import { AnalyticsCard, ShowDetails, SectionKey } from './types';

export const ANALYTICS_CARDS: AnalyticsCard[] = [
  {
    key: 'staffManagement',
    title: 'Staff Management',
    description: 'Detailed overview',
  },
  {
    key: 'dailyOperations',
    title: 'Daily Operations',
    description: 'Detailed overview',
  },
  {
    key: 'customerFeedback',
    title: 'Customer Feedback',
    description: 'Detailed overview',
  },
];

export const SECTION_KEYS: SectionKey[] = ['staffManagement', 'dailyOperations', 'customerFeedback'];

export const createShowDetailsFromKeys = (keys: string[]): ShowDetails => {
  return SECTION_KEYS.reduce((acc, key) => {
    acc[key] = keys.includes(key);
    return acc;
  }, {} as ShowDetails);
};
